<template>
  <footer>
    <div id="abbr-rules" class="container mb-4">
      <div class="container">

        <div class="pt-4 pb-4 mb-3 text-center">
          <div v-html="$t('Footer.legalrules')"></div>
        </div>
      </div>
    </div>
    <div class="navbar brand-bgcolor">
      <div class="col-sm-9 p-0">
        <ul class="list-inline mb-0" id="footer-nav">
          <li class="list-inline-item" v-html="$t('Footer.T&CLink')"></li>
          <li class="list-inline-item" v-html="$t('Footer.PrivayPolicyLink')"></li>

          <li class="list-inline-item">
            <a href="https://contact.scjbrands.com/en-us" target="_blank" title="Contact Us">{{
              $t('Footer.ContactUsLink')
            }}</a>
          </li>
          <li class="list-inline-item">
            <span class="ot-sdk-show-settings" title="">{{ $t('Footer.DNSLink')
                }}</span>
          </li>
          <!-- <li class="list-inline-item" v-html="$t('Footer.TermsOfUseLink')">   
        </li>            -->
        </ul>
        <p class="mb-0">
          <small> {{ $t('Footer.copyrighttext') }}© {{ new Date().getFullYear() }}. {{ $t('Footer.AllrightReserved') }}</small>
        </p>
      </div>
      <div class="footer-right">
        <div class="footer-social-nav">
          <ul class="list-inline m-0">
            <li>
              <p class="mb-0">Follow Us</p>
            </li>
            <li>
              <a href="http://snipp.us/!cuTGJ" class="fb-link social-icon" title="facebook" target="_blank">
                <i class="fab fa-facebook"></i>
              </a>
            </li>
            <li>
              <a href="http://snipp.us/!cuTGK" class="ig-link social-icon" title="instagram" target="_blank">
                <i class="fab fa-instagram"></i>
              </a>
            </li>
            <li>
              <a href="http://snipp.us/!cuTGL" class="yt-link social-icon" title="youtube" target="_blank">
                <i class="fab fa-youtube"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
//Younet chatbot code apprended in the body
export default {
  // mounted() {
  //   // Dynamically fetch the translated modelHash
  //   const modelHash = this.$t('YounetmodelHash');
  //   const modelImgurl = this.$t('YounetmodelIMg');
  //   const scriptUrl = `https://widget.younet.ai/index.js?modelHash=${modelHash}&type=bubble&imgUrl=${modelImgurl}`;
  //   // Dynamically create the script element
  //   const script = document.createElement('script');
  //   script.type = 'module';
  //   script.src = scriptUrl;
  //   // Append the script to the body
  //   document.body.appendChild(script);
  // },
};
</script>
